module.exports = __webpack_public_path__ + "static/media/fave-feed-modal-1.34b71c1d.svg";